jQuery(document).ready(function ($) {

    $("select").selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });

    $(".site-header-search-toggle-open").click(function () {
        $('.site-header').addClass("search_active");
        $('body').addClass("toggle_search_active");
    });

    $(".site-header-search-toggle-close").click(function () {
        $('.site-header').removeClass("search_active");
        $('body').removeClass("toggle_search_active");
    });

    $(".site-navigation-toggle").click(function () {
        $('.site-header').toggleClass("menu_active");
        $('body').toggleClass("toggle_menu_active");
        if ($('nav.primary-navigation li.menu-item-has-children').hasClass("open")) {
            $('nav.primary-navigation li.menu-item-has-children button.submenu-toggle').removeClass("active");
            $('nav.primary-navigation li.menu-item-has-children').removeClass("open");
            $('nav.primary-navigation li.menu-item-has-children .sub-menu').slideUp();
        }
    });

    $('nav.primary-navigation').find('li.menu-item-has-children > a').after('<button class="submenu-toggle"><svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.9" d="M1 1.5L6 6.5L11 1.5" stroke="#E45C39" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>');
    $('body').on('click', 'nav.primary-navigation button.submenu-toggle', function () {
        $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
        $(this).parent().siblings().find('button.submenu-toggle').parent().find('> .sub-menu').slideUp().parent().removeClass('open');
        $(this).toggleClass('active').parent().find('> .sub-menu').slideToggle().parent().toggleClass('open');
    });

    jQuery(".accordion_type .accordion_sec__list__item .content").hide();
    jQuery(".accordion_type .accordion_sec__list__item.active .content").slideDown(300);
    jQuery(".accordion_type .accordion_sec__list__item .title").on("click", function (e) {
        e.preventDefault();
        jQuery(".accordion_type .accordion_sec__list__item").removeClass("active");
        if (jQuery(this).next().is(":visible")) {
            jQuery(this).parent().parent().removeClass("active");
            jQuery(this).next().slideUp(300);
        } else {
            jQuery(".accordion_type .accordion_sec__list__item .content").slideUp(300);
            jQuery(".accordion_type .accordion_sec__list__item .title").removeClass("active");
            jQuery(this).parent().parent().addClass("active");
            jQuery(this).next().slideDown(300);
        }
    });


    jQuery(".accordion_section__list__item__inner .content").hide();
    jQuery(".accordion_section__list__item__inner .active .content").slideDown(300);
    jQuery(".accordion_section__list__item .heading").on("click", function (e) {
        e.preventDefault();
        jQuery(".accordion_section__list__item__inner").removeClass("active");
        if (jQuery(this).next().is(":visible")) {
            jQuery(this).parent().parent().removeClass("active");
            jQuery(this).next().slideUp(300);
        } else {
            jQuery(".accordion_section__list__item__inner .content").slideUp(300);
            jQuery(".accordion_section__list__item__inner .title").removeClass("active");
            jQuery(this).parent().parent().addClass("active");
            jQuery(this).next().slideDown(300);
        }
    });


    jQuery(".sidebar_inner_mobile_title,.filter_sec_inner_mob_heading").on("click", function (e) {
        e.preventDefault();
        if (jQuery(this).next().is(":visible")) {
            jQuery(this).removeClass("active");
            jQuery(this).next().slideUp();
        } else {
            jQuery(this).addClass("active");
            jQuery(this).next().slideDown();
        }
    });

    jQuery(".section_content_list_item_heading").on("click", function (e) {
        e.preventDefault();
        if ($(window).width() < 992) {
            jQuery(".section_content_list_item_heading").not(this).removeClass("active").next().slideUp();
            if (jQuery(this).next().is(":visible")) {
                jQuery(this).removeClass("active");
                jQuery(this).next().slideUp();
            } else {
                jQuery(this).addClass("active");
                jQuery(this).next().slideDown();
            }
        }
    });

    jQuery(".team_list__item__inner .hover_link").click(function () {
        setTimeout(function () {
            $('.lity').addClass('team_popup_open');
            $('body').addClass('team_popup_active');
        });
    });

    jQuery(document).on('lity:close', function (event, instance) {
        $('.lity').removeClass('team_popup_open');
        $('body').removeClass('team_popup_active');
    });

    $('.team__popup__inner .close').on('click', function () {
        $('.lity-container>.lity-close').trigger("click");
    });
    $(".team_sec").each(function (index) {
        let slide = $(this).find('.team_list__item');
        let slider = $(this).find('.team_sec__inner__list');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 3,
                variableWidth: true,
                infinite: true,
                arrows: true,
                dots: true,
                prevArrow: $(this).find('.prev_arrow'),
                nextArrow: $(this).find('.next_arrow'),
                appendDots: $(this).find('.dots'),
                autoplay: false,
                autoplaySpeed: 4000,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
                ]
            });
        }
    });

    $(".location_slider_sec").each(function (index) {
        let slide = $(this).find('.location_list__inner__item');
        let slider = $(this).find('.location_list__inner');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 3,
                variableWidth: true,
                infinite: true,
                arrows: true,
                dots: true,
                prevArrow: $(this).find('.prev_arrow'),
                nextArrow: $(this).find('.next_arrow'),
                appendDots: $(this).find('.dots'),
                autoplay: false,
                autoplaySpeed: 4000,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
                ]
            });
        }

    });


    $(".our_story_sec").each(function (index) {
        let slide = $(this).find('.our_story_item');
        let slider = $(this).find('.our_stroy_list__slider');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 3,
                variableWidth: true,
                infinite: true,
                arrows: true,
                dots: false,
                prevArrow: $(this).find('.prev_arrow'),
                nextArrow: $(this).find('.next_arrow'),
                autoplay: false,
                autoplaySpeed: 4000,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
                ]
            });
        }

    });


    $(".treatments_card_slider").each(function (index) {
        let treatments_card_list_slider = $(this).find('.treatments_card_list_slider');

        $(treatments_card_list_slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: true,
            dots: true,
            prevArrow: $(this).find('.treatments_card_slider_prev_arrow'),
            nextArrow: $(this).find('.treatments_card_slider_next_arrow'),
            appendDots: $(this).find('.treatments_card_slider_dots'),
            autoplay: false,
            autoplaySpeed: 4000,
            responsive: [{
                breakpoint: 768,
                settings: {
                    autoplay: true,
                }
            }
            ]
        });
    });
    if ($(window).width() > 767) {
        $(".latest_news").each(function (index) {
            let news_item_slider = $(this).find('.latest_news_wrapper_list');
            let news_item_slide = $(this).find('.news_item');
            let news_prev = $(this).find('.latest_news_wrapper_data_arrows_prev');
            let news_next = $(this).find('.latest_news_wrapper_data_arrows_next');
            if ($(news_item_slide).length > 1) {
                $(news_item_slider).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    infinite: true,
                    arrows: true,
                    dots: false,
                    prevArrow: news_prev,
                    nextArrow: news_next,
                    autoplay: false,
                    autoplaySpeed: 4000,
                });
            }
        });
    }

    jQuery(".testimonials_list_item_inner_media_play").click(function () {
        setTimeout(function () {
            $('.lity').addClass('media_popup');
        });
    });

    $(".testimonials").each(function (index) {

        let sliderNav = $(this).find('.testimonials_list_nav');
        let sliderFor = $(this).find('.testimonials_list_for');
        let slideNav = $(sliderNav).find('.testimonials_list_item');
        let slideFor = $(sliderFor).find('.testimonials_list_item');


        $(sliderNav).on('init beforeChange afterChange', function (event, slick, currentSlide, nextSlide) {
            var dotHtml = $(this).find('> ul.slick-dots').clone();
            $(this).find('.slick-current .testimonials_list_item_inner_data_wrapper_dots').html(dotHtml);
        });

        if ($(slideNav).length == 1) {
            var dotsCustom = false;
        } else {
            var dotsCustom = true;
        }
        if ($(slideNav).length > 1) {
            $(sliderNav).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
                infinite: true,
                arrows: false,
                dots: dotsCustom,
                asNavFor: sliderFor,
                autoplay: true,
                autoplaySpeed: 6000
            });
        }
        if ($(slideFor).length > 1) {
            $(sliderFor).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: sliderNav
            });
        }
        $('body').on("click", '.testimonials_list_nav .testimonials_list_item .slick-dots button', function (e) {
            e.preventDefault();
            var slideno = $(this).text();
            var slideParent = $(this).closest(".testimonials_list_nav");
            $(slideParent).slick('slickGoTo', slideno - 1);
        });
    });

    offsetLeft();
    //fixSidebarOnScroll();

    customSelect();
    startnumbers();

    // $(".contact_us_section .gform_footer button.button").addClass('btn small_btn');

});

jQuery(window).resize(function () {
    offsetLeft();
});

function offsetLeft() {
    if ((jQuery('.team_sec__inner__list').length > 0)) {
        var applicationsoffset = jQuery('.team_sec__inner__list').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.team_sec__inner__list').css('width', (applicationswindWidth - applicationsoffset.left));
    }
    if ((jQuery('.location_list__inner').length > 0)) {
        var applicationsoffset = jQuery('.location_list__inner').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.location_list__inner').css('width', (applicationswindWidth - applicationsoffset.left));
    }
    if ((jQuery('.treatments_card_list_offset').length > 0)) {
        var applicationsoffset = jQuery('.treatments_card_list_offset').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.treatments_card_list_offset').css('width', (applicationswindWidth - applicationsoffset.left));
    }

    if ((jQuery('.our_story_sec').length > 0)) {
        var applicationsoffset = jQuery('.our_stroy_list__slider').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.our_stroy_list__slider').css('width', (applicationswindWidth - applicationsoffset.left));
    }

    if ((jQuery('.our_story_sec').length > 0)) {
        var applicationsoffset = jQuery('.heading_sec__inner').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.heading_sec__inner').css('width', (applicationswindWidth - applicationsoffset.left));
    }

    if (jQuery(window).width() > 767) {
        if ((jQuery('.latest_news_wrapper_list > .slick-list').length > 0)) {
            var applicationsoffset = jQuery('.latest_news_wrapper_list > .slick-list').offset(),
                applicationswindWidth = jQuery(window).width();
            jQuery('.latest_news_wrapper_list > .slick-list').css('width', (applicationswindWidth - applicationsoffset.left));
        }
    }
}

jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
    customSelect();
});

jQuery(window).resize(function () {
    if (jQuery(window).width() > 767) {
        jQuery(".latest_news").each(function (index) {
            let news_item_slider = jQuery(this).find('.latest_news_wrapper_list');
            let news_item_slide = jQuery(this).find('.news_item');
            let news_prev = jQuery(this).find('.latest_news_wrapper_data_prev');
            let news_next = jQuery(this).find('.latest_news_wrapper_data_next');
            if (jQuery(news_item_slide).length > 1) {
                jQuery(news_item_slider).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    infinite: true,
                    arrows: true,
                    dots: false,
                    prevArrow: news_prev,
                    nextArrow: news_next,
                    autoplay: false,
                    autoplaySpeed: 4000,
                });
            }
        });
    } else {
        if (jQuery('.latest_news_wrapper_list').hasClass("slick-initialized")) {
            jQuery('.latest_news_wrapper_list').slick("unslick");
            jQuery('.latest_news_wrapper_list').removeAttr("style");
        }
    }
});

function customSelect() {
    jQuery('select').selectric();
    jQuery(document).ready(function () {
        jQuery(document).on("change", ".gfield select", function () {
            var val1 = jQuery(this).val();
            if (val1 != "") {
                jQuery(this).parent().parent().find(".selectric").addClass("selected");
            } else {
                jQuery(this).parent().parent().find(".selectric").removeClass("selected");
            }
        });
        jQuery(".gfield select").each(function () {
            var val1 = jQuery(this).val();
            if (val1 != "") {
                jQuery(this).parent().parent().find(".selectric").addClass("selected");
            } else {
                jQuery(this).parent().parent().find(".selectric").removeClass("selected");
            }
        })
    });
}

var numbers_section_reached = false;

jQuery(window).on("scroll", function () {
    if (jQuery(".section_content_list_item_content_list_item.number_list").length > 0) {
        jQuery(".section_content_list_item_content_list_item.number_list").each(function () {
            var numbers_section = jQuery(this).offset().top;
            if ((numbers_section <= (jQuery(window).scrollTop() + (jQuery(window).height() * 0.5))) && !jQuery(this).hasClass("enabled")) {
                startnumbers(this);
                jQuery(this).addClass("enabled")
            }
        })
    }
    //fixSidebarOnScroll();
});

// function fixSidebarOnScroll() {
//     var sidebar = jQuery('.filter_sec_inner');
//     var sidebarTop = sidebar.position().top;
//     var blogHeight = jQuery('.post_sec').outerHeight() - (-500);
//     var windowScrollTop = jQuery(window).scrollTop();
//     if (windowScrollTop >= blogHeight || windowScrollTop <= sidebarTop) {
//         sidebar.removeClass('sticky');
//     }
//     else if (windowScrollTop >= sidebarTop) {
//         if (!sidebar.hasClass('sticky')) {
//             sidebar.addClass('sticky');
//         }
//     }
// }

function startnumbers(obj) {
    jQuery(obj).find('.content_stats_number .content_stats_number_count').each(function () {

        if (jQuery(this).data('animated')) {
            return;
        }

        var $this = jQuery(this),
            countTo = $this.attr('data-count');

        jQuery({
            countNum: $this.text()
        }).animate({
            countNum: countTo
        }, {
            duration: 1000,
            easing: 'linear',
            step: function () {
                $this.text(commaSeparateNumber(Math.floor(this.countNum)));
            },
            complete: function () {
                $this.text(commaSeparateNumber(this.countNum));
                $this.data('animated', true);
            }
        });
    });
}


function commaSeparateNumber(val) {
    while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
    }
    return val;
}